import { render, staticRenderFns } from "./addFeeCombo.vue?vue&type=template&id=50067a2a&scoped=true"
import script from "./addFeeCombo.vue?vue&type=script&lang=js"
export * from "./addFeeCombo.vue?vue&type=script&lang=js"
import style0 from "./addFeeCombo.vue?vue&type=style&index=0&id=50067a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50067a2a",
  null
  
)

export default component.exports